import { createReducer, on } from '@ngrx/store';
import { DeviceApiActions, DeviceSignalRHubActions, DeviceActionsActions } from './device.actions';
import { adapter, initialState, selectDeviceId } from './device.state';

export const deviceReducer = createReducer(
  initialState,
  on(DeviceApiActions.deviceLoaded, (state, { devices }) => adapter.upsertMany(devices, state)),
  on(
    DeviceApiActions.deviceUnassigned,
    DeviceApiActions.deviceAssigned,
    DeviceApiActions.deviceMarkedAsSpare,
    DeviceApiActions.deviceUnavailable,
    DeviceApiActions.deviceMarkedAsHousekeeping,
    DeviceApiActions.deviceMarkedAsStaff,
    DeviceApiActions.deviceMarkedAsFrontDesk,
    DeviceApiActions.deviceMarkedAsBar,
    DeviceApiActions.deviceMarkedAsKiosk,
    DeviceSignalRHubActions.deviceChanged,
    (state, { device }) => adapter.upsertOne(device, state)
  ),
  on(DeviceSignalRHubActions.deviceRemoved, (state, { device }) => adapter.removeOne(selectDeviceId(device), state)),
  on(DeviceActionsActions.setDesiredNameSucceeded, (state, { device }) => adapter.upsertOne(device, state))
);

const { selectIds, selectEntities, selectAll } = adapter.getSelectors();

export const selectDeviceIds = selectIds;

export const selectDeviceEntities = selectEntities;

export const selectAllDevices = selectAll;
